/**
 * @generated SignedSource<<ef1d6cee8beb4d242add78fec7ad8678>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sectionTopPostMagazineQuery$variables = {
  excludedArticleIds: ReadonlyArray<string | null | undefined>;
};
export type sectionTopPostMagazineQuery$data = {
  readonly sectionTopPostMagazine: {
    readonly subSections: {
      readonly entityId: string;
      readonly items: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly entityId?: string;
            readonly topStories?: {
              readonly items: {
                readonly edges: ReadonlyArray<{
                  readonly " $fragmentSpreads": FragmentRefs<"onePostMagSectionTopWidgetArticles" | "threePostMagSectionTopWidgetArticles" | "twoPostMagSectionTopWidgetArticles">;
                }>;
              } | null | undefined;
            } | null | undefined;
            readonly " $fragmentSpreads": FragmentRefs<"onePostMagSectionTopWidgetSection" | "threePostMagSectionTopWidgetSection" | "twoPostMagSectionTopWidgetSection">;
          };
        }>;
      } | null | undefined;
    } | null | undefined;
  };
};
export type sectionTopPostMagazineQuery = {
  response: sectionTopPostMagazineQuery$data;
  variables: sectionTopPostMagazineQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "excludedArticleIds"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "entityId": "71"
    }
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 6
  }
],
v4 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityIds",
        "variableName": "excludedArticleIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "exclude"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v10 = [
  (v9/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v11/*: any*/)
  ],
  "storageKey": null
},
v14 = [
  (v2/*: any*/),
  (v11/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": (v14/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentSection",
      "storageKey": null
    }
  ],
  "type": "Section",
  "abstractKey": null
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flattenTypeIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LiveArticle",
      "kind": "LinkedField",
      "name": "liveArticle",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        (v11/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegment",
      "kind": "LinkedField",
      "name": "sections",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Section",
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": (v14/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
},
v18 = [
  (v2/*: any*/)
],
v19 = {
  "kind": "InlineFragment",
  "selections": (v18/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v20 = {
  "kind": "InlineFragment",
  "selections": (v18/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    (v11/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PaywallType",
      "kind": "LinkedField",
      "name": "paywallTypes",
      "plural": true,
      "selections": [
        (v12/*: any*/),
        (v11/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v5/*: any*/),
            (v19/*: any*/),
            (v20/*: any*/),
            (v21/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v22/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v24 = [
  (v7/*: any*/)
],
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v19/*: any*/),
        (v20/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sectionTopPostMagazineQuery",
    "selections": [
      {
        "alias": "sectionTopPostMagazine",
        "args": (v1/*: any*/),
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "subSections",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Queue",
                                "kind": "LinkedField",
                                "name": "topStories",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": (v4/*: any*/),
                                    "concreteType": "QueueItemConnection",
                                    "kind": "LinkedField",
                                    "name": "items",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "QueueItemsEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "onePostMagSectionTopWidgetArticles"
                                          },
                                          {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "twoPostMagSectionTopWidgetArticles"
                                          },
                                          {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "threePostMagSectionTopWidgetArticles"
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v2/*: any*/),
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "onePostMagSectionTopWidgetSection"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "twoPostMagSectionTopWidgetSection"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "threePostMagSectionTopWidgetSection"
                              }
                            ],
                            "type": "Section",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:6)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "section(filter:{\"entityId\":\"71\"})"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sectionTopPostMagazineQuery",
    "selections": [
      {
        "alias": "sectionTopPostMagazine",
        "args": (v1/*: any*/),
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "subSections",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Queue",
                                "kind": "LinkedField",
                                "name": "topStories",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": (v4/*: any*/),
                                    "concreteType": "QueueItemConnection",
                                    "kind": "LinkedField",
                                    "name": "items",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "QueueItemsEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v5/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v2/*: any*/),
                                                  (v6/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Topic",
                                                    "kind": "LinkedField",
                                                    "name": "topics",
                                                    "plural": true,
                                                    "selections": [
                                                      (v2/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "Sponsor",
                                                        "kind": "LinkedField",
                                                        "name": "sponsor",
                                                        "plural": false,
                                                        "selections": [
                                                          (v7/*: any*/),
                                                          (v8/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Image",
                                                            "kind": "LinkedField",
                                                            "name": "images",
                                                            "plural": true,
                                                            "selections": (v10/*: any*/),
                                                            "storageKey": null
                                                          },
                                                          (v11/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      (v11/*: any*/),
                                                      (v6/*: any*/),
                                                      (v7/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "shortName",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          (v5/*: any*/),
                                                          (v12/*: any*/),
                                                          (v13/*: any*/),
                                                          (v15/*: any*/),
                                                          (v16/*: any*/),
                                                          (v17/*: any*/),
                                                          (v23/*: any*/)
                                                        ],
                                                        "type": "BaseWithApplicationAndUrlAlias",
                                                        "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "headline",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Image",
                                                    "kind": "LinkedField",
                                                    "name": "images",
                                                    "plural": true,
                                                    "selections": [
                                                      (v9/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "title",
                                                        "storageKey": null
                                                      },
                                                      (v8/*: any*/),
                                                      {
                                                        "alias": "size1200x800",
                                                        "args": [
                                                          {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                              "style": "1200x800"
                                                            }
                                                          }
                                                        ],
                                                        "concreteType": "ImageStyle",
                                                        "kind": "LinkedField",
                                                        "name": "style",
                                                        "plural": false,
                                                        "selections": (v10/*: any*/),
                                                        "storageKey": "style(filter:{\"style\":\"1200x800\"})"
                                                      },
                                                      {
                                                        "alias": "size768x768",
                                                        "args": [
                                                          {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                              "style": "768x768"
                                                            }
                                                          }
                                                        ],
                                                        "concreteType": "ImageStyle",
                                                        "kind": "LinkedField",
                                                        "name": "style",
                                                        "plural": false,
                                                        "selections": (v10/*: any*/),
                                                        "storageKey": "style(filter:{\"style\":\"768x768\"})"
                                                      },
                                                      {
                                                        "alias": "size540x360",
                                                        "args": [
                                                          {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                              "style": "540x360"
                                                            }
                                                          }
                                                        ],
                                                        "concreteType": "ImageStyle",
                                                        "kind": "LinkedField",
                                                        "name": "style",
                                                        "plural": false,
                                                        "selections": (v10/*: any*/),
                                                        "storageKey": "style(filter:{\"style\":\"540x360\"})"
                                                      },
                                                      {
                                                        "alias": "size800x1200",
                                                        "args": [
                                                          {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                              "style": "portrait"
                                                            }
                                                          }
                                                        ],
                                                        "concreteType": "ImageStyle",
                                                        "kind": "LinkedField",
                                                        "name": "style",
                                                        "plural": false,
                                                        "selections": (v10/*: any*/),
                                                        "storageKey": "style(filter:{\"style\":\"portrait\"})"
                                                      },
                                                      {
                                                        "alias": "size500x500",
                                                        "args": [
                                                          {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                              "style": "500x500"
                                                            }
                                                          }
                                                        ],
                                                        "concreteType": "ImageStyle",
                                                        "kind": "LinkedField",
                                                        "name": "style",
                                                        "plural": false,
                                                        "selections": (v10/*: any*/),
                                                        "storageKey": "style(filter:{\"style\":\"500x500\"})"
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "socialHeadline",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "flag",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "SectionSegmentV2",
                                                    "kind": "LinkedField",
                                                    "name": "sectionsV2",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": null,
                                                        "kind": "LinkedField",
                                                        "name": "value",
                                                        "plural": true,
                                                        "selections": [
                                                          (v5/*: any*/),
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": (v24/*: any*/),
                                                            "type": "Section",
                                                            "abstractKey": null
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": (v24/*: any*/),
                                                            "type": "VideoSection",
                                                            "abstractKey": null
                                                          },
                                                          (v21/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v12/*: any*/),
                                                      (v13/*: any*/),
                                                      (v15/*: any*/),
                                                      (v16/*: any*/),
                                                      (v17/*: any*/),
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          (v25/*: any*/),
                                                          (v22/*: any*/)
                                                        ],
                                                        "type": "Content",
                                                        "abstractKey": "__isContent"
                                                      }
                                                    ],
                                                    "type": "BaseWithApplicationAndUrlAlias",
                                                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "sponsorType",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "ArticleTypeSegment",
                                                        "kind": "LinkedField",
                                                        "name": "types",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ArticleType",
                                                            "kind": "LinkedField",
                                                            "name": "value",
                                                            "plural": true,
                                                            "selections": [
                                                              (v7/*: any*/),
                                                              (v2/*: any*/),
                                                              (v26/*: any*/),
                                                              (v11/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "Author",
                                                        "kind": "LinkedField",
                                                        "name": "authors",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "types",
                                                            "storageKey": null
                                                          },
                                                          (v11/*: any*/),
                                                          (v2/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          (v25/*: any*/)
                                                        ],
                                                        "type": "Content",
                                                        "abstractKey": "__isContent"
                                                      }
                                                    ],
                                                    "type": "Article",
                                                    "abstractKey": null
                                                  }
                                                ],
                                                "type": "Content",
                                                "abstractKey": "__isContent"
                                              },
                                              (v21/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v11/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v2/*: any*/),
                              (v7/*: any*/),
                              (v26/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v12/*: any*/),
                                  (v6/*: any*/),
                                  (v13/*: any*/),
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v23/*: any*/)
                                ],
                                "type": "BaseWithApplicationAndUrlAlias",
                                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                              }
                            ],
                            "type": "Section",
                            "abstractKey": null
                          },
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:6)"
              },
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          (v11/*: any*/)
        ],
        "storageKey": "section(filter:{\"entityId\":\"71\"})"
      }
    ]
  },
  "params": {
    "cacheID": "f8fd52a6a607bc1aa3cf3313b74e4675",
    "id": null,
    "metadata": {},
    "name": "sectionTopPostMagazineQuery",
    "operationKind": "query",
    "text": "query sectionTopPostMagazineQuery(\n  $excludedArticleIds: [String]!\n) {\n  sectionTopPostMagazine: section(filter: {entityId: \"71\"}) {\n    subSections {\n      entityId\n      items(first: 6) {\n        edges {\n          node {\n            __typename\n            ... on Section {\n              topStories {\n                items(first: 10, exclude: {entityIds: $excludedArticleIds}) {\n                  edges {\n                    ...onePostMagSectionTopWidgetArticles\n                    ...twoPostMagSectionTopWidgetArticles\n                    ...threePostMagSectionTopWidgetArticles\n                  }\n                }\n                id\n              }\n              entityId\n              ...onePostMagSectionTopWidgetSection\n              ...twoPostMagSectionTopWidgetSection\n              ...threePostMagSectionTopWidgetSection\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment contentCoverImageContent_1X8xbh on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size768x768: style(filter: {style: \"768x768\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_1pemU3 on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size500x500: style(filter: {style: \"500x500\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_3Xh6CG on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size800x1200: style(filter: {style: \"portrait\"}) {\n      url\n    }\n  }\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentSponsorTagContent on Content {\n  __isContent: __typename\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentTopicLinkContent on Content {\n  __isContent: __typename\n  topics {\n    urlAlias\n    ...entityLink\n    ...topicLinkTopic\n    id\n  }\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersSanitizeArticleTypeEntityIdsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeAuthorTypesArticle on Article {\n  authors {\n    types\n    id\n  }\n}\n\nfragment helpersSanitizedAuthorEntityIdsArticle on Article {\n  authors {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        description {\n          text\n        }\n        id\n      }\n    }\n    ...helpersCheckIsStyleArticle\n  }\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ...hooksContentHelperContent\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ...helpersSanitizeArticleTypeEntityIdsArticle\n  ...helpersSanitizeAuthorTypesArticle\n  ...helpersSanitizedAuthorEntityIdsArticle\n  flag\n}\n\nfragment hooksContentItemProvidersContent_1YIyJs on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_1pemU3\n  ...contentHeadlineContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3hlRa7 on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_3Xh6CG\n  ...contentHeadlineContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_9hDaW on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_1X8xbh\n  ...contentHeadlineContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment onePostMagSectionTopWidgetArticles on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...postMagazinePrimaryContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment onePostMagSectionTopWidgetSection on Section {\n  name\n  description {\n    text\n  }\n  ...entityLink\n}\n\nfragment postMagazinePrimaryContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_9hDaW\n}\n\nfragment postMagazineSectionWidgetThreeContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_1YIyJs\n}\n\nfragment postMagazineSectionWidgetTwoContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_3hlRa7\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment threePostMagSectionTopWidgetArticles on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...postMagazineSectionWidgetThreeContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment threePostMagSectionTopWidgetSection on Section {\n  name\n  description {\n    text\n  }\n  ...entityLink\n}\n\nfragment topicLinkTopic on Topic {\n  ...entityLink\n  name\n  shortName\n}\n\nfragment twoPostMagSectionTopWidgetArticles on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...postMagazineSectionWidgetTwoContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment twoPostMagSectionTopWidgetSection on Section {\n  name\n  description {\n    text\n  }\n  ...entityLink\n}\n"
  }
};
})();

(node as any).hash = "81bb6dff3ef7c5d36efc0f84ed4aae20";

export default node;
